import Page from './Page';

if ('serviceWorker' in navigator && 'PushManager' in window) {

    getPublicVapidId().then( vapidPublicKey => {
        if(vapidPublicKey) {
            Notification.requestPermission().then(function (permission) {
                if (permission === 'granted') {
                    return navigator.serviceWorker.ready.then(function (registration) {
                        return registration.pushManager.subscribe({
                            userVisibleOnly: true,
                            applicationServerKey: vapidPublicKey
                        });
                    });
                }
            }).then(function (subscription) {
                if (subscription) { sendTokenToServer(subscription); }
            })
            .catch(function (error) {
                console.error('Erro ao registrar o Service Worker ou solicitar permissão de notificações:', error);
            });
        }
    });
}

function sendTokenToServer(token) {
    fetch(Page.getApplicationPath() + `api/v1/tec/pushnotification/token`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(token),
    })
}

function getPublicVapidId() {
    return fetch(Page.getApplicationPath() + `api/v1/tec/pushnotification/vapidpublickey`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    })
    .then(response => {
        if (!response.ok) throw new Error('Erro ao buscar VAPID key');

        return response.json();
    })
}